module.exports = __webpack_public_path__ + "static/media/51.f3fc2bb3.jpg";